import { render } from "./TabMyWork.vue?vue&type=template&id=66a571b0"
import script from "./TabMyWork.vue?vue&type=script&lang=js"
export * from "./TabMyWork.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__